import React, { useState, useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";
import { FilterBar } from "../../../components/molecule/molecule";
import { AgGridAtom, ModalAtom } from '../../../components/atoms/atom';
import { getOrganisationTableColumns } from './constant';
import AddDepartmentModal from './add/add-department';
import { getSearchAddFilter } from '../../../utils/get-filter-items';
import { searchData } from '../../../utils/search';
import { setting } from '../../../store/services/index';
import { showToast, getFormattedDate, showError } from '../../../utils/method';
import SettingsMenu from '../settings-menu/settings-menu';
import { AuthContext } from "../../../contexts/AuthProvider";

function OrganisationSettingPage() {
    const { t } = useTranslation();
    const { helpMode } = useContext(AuthContext);
    const [orgModalView, setOrgModalView] = useState('');
    const [selectedOrganisation, setSelectedOrganisation] = useState({});
    const [showDeleteModal, setShowdeleteModal] = useState(false);
    const filterItems = getSearchAddFilter(t, { addTextKey: 'add-organisation' });
    const [leftFilterItems, setLeftFilterItems] = useState(filterItems.left || []);
    const [rightFilterItems] = useState(filterItems.right || []);
    const [organisationsList, setOrganisationsList] = useState([]);
    const [filterdOrganisationList, setFilterdOrganisationList] = useState([]);

    const fetchOrganisations = async () => {
        try{
            let result = await setting.getDepartment();
            result = (result?.data || []).map((record) => {
                return {
                    ...record,
                    provided: getFormattedDate(record.createdAt)
                }
            });
            setOrganisationsList(result);
            setFilterdOrganisationList(result);
        } catch(error){
            showError(t, error);
        }
    }
    
    useEffect(() => {
        fetchOrganisations();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onOrganisationEdit = (row, rowIndex) => {
        const groups = (row?.groups || []).map((group) =>  {
            return {
                label: group?.name,
                value: group?.id
            }
        });
        const processes = (row?.processes || []).map((process) => {
            return {
                label: process?.name,
                value: process?.id
            }
        });
        setSelectedOrganisation({...row, groups, processes});
        setOrgModalView('edit');
    };

    const onOrganisationDelete = (row, rowIndex) => {
        setSelectedOrganisation(row);
        setShowdeleteModal(true);
    };
    const onDeleteOrganisation = async () => {
        try {
            const res = await setting.deleteDepartment(selectedOrganisation?.id);
            showToast(t(res?.message), { type: 'success' });
            fetchOrganisations();
            setShowdeleteModal(false);
        } catch(error) {
            showToast(t(error?.message), { type: 'error' });
        }
    }

    
    const onAddOrganisation = async (organisationInfo) => {
        try {
            if (orgModalView === 'add') {
                const res = await setting.addDepartment({
                    name: organisationInfo.name,
                    groups: organisationInfo.groups,
                    processes: organisationInfo.process,
                });
                showToast(t(res?.message), { type: 'success' });
            } else if (orgModalView === 'edit') {
                const res = await setting.updateDepartment({
                    name: organisationInfo.name,
                    groups: organisationInfo.groups,
                    processes: organisationInfo.process,
                }, organisationInfo.id);
                showToast(t(res?.message), { type: 'success' });
            }
            fetchOrganisations();
            setOrgModalView('');
        } catch (error) {
            showError(t, error);
        }
    };
    const organisationsColumns = getOrganisationTableColumns(t, onOrganisationEdit, onOrganisationDelete, helpMode);

    const onFilterAction = (index, key, info) => {
        if (key === 'search') {
            const localLeftFilterItems = [...leftFilterItems];
            localLeftFilterItems[0].value = info?.value;
            setLeftFilterItems(localLeftFilterItems);
            const filteredRoleList = searchData(info?.value, organisationsList, organisationsColumns.slice(0, -1));
            setFilterdOrganisationList(filteredRoleList);
        }
        if (key === 'add') {
            setSelectedOrganisation({});
            setOrgModalView('add');
        }
    };

    return (
        <>
            <SettingsMenu />
            <FilterBar 
                leftItems={leftFilterItems}
                rightItems={rightFilterItems}
                onFilterAction={onFilterAction} />

            <AgGridAtom 
                columnDefs={organisationsColumns}
                rowData={filterdOrganisationList}
            />
            
            {orgModalView && <AddDepartmentModal 
                mode={orgModalView}
                orgInfo={selectedOrganisation}
                show
                onClose={() => {setOrgModalView('');  setSelectedOrganisation('')} }
                onSubmit={onAddOrganisation}
            />}
            <ModalAtom 
                title={t('delete-organisation')}
                body = {<p>{t('delete-organisation-warning')}</p>}
                saveText="delete"
                show={showDeleteModal} 
                handleClose={() => setShowdeleteModal(false) }
                handleSubmit={onDeleteOrganisation}
            />
        </>
    );
}

export default OrganisationSettingPage;
